<template>
    <div class="apprentice-simple-card notifications-list">
        <ul class="list-unstyled notifications-list-group" v-if="notificationsIn.length >= 1">
            <b-media tag="li" v-for="notification in notifications" :key="notification.id" class="notification" :class="notification.read_at === null && 'unread'">
                <template #aside>
                    <i class="notification-icon" :class="notification.web_icon"></i>
                </template>

                <div class="notification-header">
                    <span class="notification-status"></span>
                    <h5 class="notification-title">{{notification.title}}</h5>
                </div>

                <div class="notification-date">
                    {{notification.created_at | date_time_om}}
                </div>
                <div class="notification-description">
                    {{notification.description}}
                </div>
                <a :href="`notification/${notification.id}`" class="clickable"></a>
            </b-media>
        </ul>
        <div class="not-found with-header empty-notification-list" v-else>
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{$t('notification.no_notifications')}}</div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "design-2021-notifications-index-component",
    props: {
        notificationsIn: Array,
    },
    data() {
        return {
            notifications: this.notificationsIn.sort((date1, date2) => {
                return new this.moment(date1.date).format('yyyy-MM-DD H:mm:ss') - new this.moment(date2.date).format('yyyy-MM-DD H:mm:ss');
            })
        }
    },

    methods: {
        getNotificationTypeIcon(type) {

            switch (type) {
                case 'App\\Notifications\\RubricSurveyStudentInviteNotification':
                case 'App\\Notifications\\RubricSurveyStudentPeerInviteNotification':
                    return 'btn-check-list';

                case 'App\\Notifications\\AssignmentFeedbackNotification':
                case 'App\\Notifications\\SubAssignmentFeedbackNotification':
                    return 'btn-comments-fad';

                case 'App\\Notifications\\MessageCreateNotification':
                    return 'btn-envelope-fad';

                case 'App\\Notifications\\InvitesStudentsNotification':
                    return 'btn-account';

                case 'App\\Notifications\\CalendarItemAddNotification':
                    return 'btn-calendar-add';

                case 'App\\Notifications\\CalendarItemUpdateNotification':
                    return 'btn-calendar-update';

                case 'App\\Notifications\\CalendarItemDeleteNotification':
                    return 'btn-calendar-remove';

                case 'App\\Notifications\\InviteSurveyStudent':
                    return 'btn-poll-people '
            }
        }
    },

    mounted(){
        Vue.nextTick(() => {
            this.notifications = this.notificationsIn.sort(( a, b) => {
                return new Date(b.created_at) - new Date(a.created_at);
            })
        });
    }
}
</script>

<style scoped lang="scss">
    .notification {
        padding: map-get($grid-padding-spacing, 'fifteen') map-get($grid-padding-spacing, 'ten');
        position: relative;

        .notification-icon {
            font-style: normal;
            font-size: 3rem;
            color: $primary;
            width: 60px;

            &:before {
                margin-right: 0;
            }
        }

        .media-body,
        .media-aside {
            opacity: 0.5;
        }

        .notification-header {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .notification-status {
                align-self: flex-start;
            }

            .notification-title {
                margin-bottom: 0;
            }

            .remove-notification {
                font-size: 1.3125rem;
                align-self: flex-start;
                font-weight: $font-weight-bold;
                color: $danger;
                margin-left: auto;

                &:before {
                    margin-right: 0;
                }

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .notification-date {
            font-size: 0.75rem;
            font-weight: $font-weight-medium;
            color: $text-muted-color;
            margin-bottom: map-get($grid-padding-spacing, 'ten');
        }

        &:not(:last-child) {
            margin-bottom: map-get($grid-padding-spacing, 'fifteen');
            border-bottom: 3px dotted $border-color;
        }

        &.unread {
            .media-body,
            .media-aside {
                opacity: 1;
            }
        }

        &:hover {
            background-color: $secondary-background-color;
            border-radius: $border-radius-content;
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'xl')){
        .notification {
            .media-body {
                max-width: 33.333%;
            }
        }
    }
</style>
